import { M8PartnerDTO } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

type Params = {
  idPartner: number;
};

export const getPartner = async (params: Params): Promise<M8PartnerDTO> => {
  const fetchURL = getM8AdminURL(`getPartner?${createQueryString(params)}`);

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
